import React, { useState } from "react";
import "./index.scss";
import Paragraph from "../../atoms/paragraph";
import Button, { ButtonType } from "../../atoms/button";
import SectionTitle from "../../atoms/section-title";
import Modal from "../modal";
import Accordion, { AccordionType } from "../accordion";
import AccordionData from "../accordion/lib/AccordionData";
import {translate} from "../../../lib/util/LanguageUtils";


interface BoxProps {
    linkAccessDataForm: string,
}

const FrontPageBox = ({
    linkAccessDataForm
} : BoxProps) => {
    const baseClassName = 'm-frontpage-box';
    const [isHelpModalOpen, setHelpModalOpen] = useState(false);

    const accordionItems : AccordionData[] = [
        {
            id: '1',
            title: translate('help_popup_login_title'),
            description: translate('help_popup_login_description'),
        },
        {
            id: '2',
            title: translate('help_popup_register_swissid_present_title'),
            description: translate('help_popup_register_swissid_present_description').replace('{{linkAccessDataForm}}', linkAccessDataForm),
        },
        {
            id: '3',
            title: translate('help_popup_register_no_swissid_present_title'),
            description: translate('help_popup_register_no_swissid_present_description').replace('{{linkAccessDataForm}}', linkAccessDataForm),
        },
        {
            id: '4',
            title: translate('help_popup_issue_with_swissid_title'),
            description: translate('help_popup_issue_with_swissid_description').replace('{{swissIdContactLink}}', translate('plf_onboarding_infobox_swissid_link')),
        },
    ];

    return (
        <div className="container-lg">
            <div className={`${baseClassName}`}>
                <div className={`${baseClassName}__col explanation-box`}>
                    <div className={`${baseClassName}__image-wrapper`}>
                        <img alt={translate('frontpage_login_image_information')} src="/design/img/swissid/login_smartphone.svg" />
                    </div>
                    <div className={`${baseClassName}__col-content`}>
                        <SectionTitle level={2} title={translate('frontpage_login_explanation_title')}/>
                        <div>
                            <p className={`${baseClassName}__subtitle`}>{translate('frontpage_login_explanation_subtitle')}</p>
                            <p dangerouslySetInnerHTML={{ __html: translate('frontpage_login_explanation_description') }}></p>
                        </div>
                        <p className={`mt-1 mb-0`}>
                            {translate('frontpage_help_text')}
                            <Button type={ButtonType.Link} hasArrow={false} handleClick={() => setHelpModalOpen(true)} text={translate('frontpage_help_btn_text')}/>
                        </p>
                    </div>
                </div>
                <div className={`${baseClassName}__col`}>
                    <div className={`${baseClassName}__col-content`}>
                        <SectionTitle frontpage headline level={1} title={translate('frontpage_login_title')} />
                        <Paragraph className={`${baseClassName}__text`}>{translate('frontpage_login_intro')}</Paragraph>
                        <div className={`${baseClassName}__buttons`}>
                            <Button href={translate('frontpage_login_btn_left_link')} target="_self" text={translate('frontpage_login_btn_left_text')} type={ButtonType.SwissID} />
                        </div>
                    </div>
                    <Modal isOpen={isHelpModalOpen} setIsOpen={setHelpModalOpen} title={translate('help_popup_title')}>
                        <Accordion data={accordionItems} type={AccordionType.Bold} />
                    </Modal>
                </div>
            </div>
        </div>
    );
};

FrontPageBox.defaultProps = {};

export default FrontPageBox;
